import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useFetch, usePost, isNormalInteger } from '../../../../components/component-items/helpers'
import { globalState } from '../../../../store'
import { useParams } from 'react-router-dom'

// Components
import GlobalStyles from '../../../../components/component-items/styles'
import GenericModal from '../../../../components/component-items/modal'
import { TableCell } from '../../../../components/component-items/datatable'
import { Form, InputGroup } from 'react-bootstrap'
import { BackgroundLayer, ProductModalStyled } from './styles'
import CardLoading from '../../../../components/component-items/loading-popover'
import { SearchBox } from '../../../../components/component-items/search'

import { BundleModalProps } from './types'

export const BundleModal = ({ bundleItems: initialBundleItems = [], open, setOpen }: BundleModalProps) => {
  const productVariant = useParams<{ id: string }>().id
  const {
    state: { csrf },
  } = globalState()

  const [productCount, setProductCount] = useState([])
  const [search, setSearch] = useState<string>('')
  const [added, setAdded] = useState<any>([])
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [bundleItems, setBundleItems] = useState(initialBundleItems)

  // add item to Bundled Items list
  const handleAddItem = (p: any) => {
    if ((productCount[p.pId] && isNormalInteger(productCount[p.pId])) || p.qty) {
      setAdded((added: any) => ({ ...added, [p.pId]: { ...p, qty: productCount[p.pId] || p.qty } }))
      const newCount = { ...productCount }
      delete newCount[p.pId]
      setProductCount(newCount)
    }
  }

  // remove item from Bundled Items list
  const handleRemoveItem = (pId: string) => {
    const clone = added
    delete clone[pId]
    setAdded({ ...clone })
  }

  // get existing bundle items, if any
  const { response: bundlesResp, loaded: bundlesLoaded } = useFetch(
    `/api/product/variant/${productVariant}/bundles/`,
    {}
  )

  useEffect(() => {
    setLoading(!bundlesLoaded)

    let items = bundleItems

    if (bundlesLoaded && bundlesResp?.bundleItems && bundleItems.length === 0) {
      setBundleItems(bundlesResp.bundleItems)
      items = bundlesResp.bundleItems
    }

    if (items) {
      items.forEach((p: any) => {
        handleAddItem(p)
      })
    }
  }, [bundlesLoaded])

  // item search
  const { response: resp, loaded: loaded }: any = useFetch(
    `/api/product/variant/${productVariant}/bundle_list/?q=${encodeURIComponent(search)}`,
    {}
  )
  const productSearch = loaded ? resp?.products || [] : []

  useEffect(() => {
    setLoading(!loaded)
  }, [loaded])

  const buttons = (
    <>
      <GlobalStyles.Button className="secondary" style={{ minWidth: 125 }} onClick={() => setOpen(false)}>
        Close
      </GlobalStyles.Button>
      <GlobalStyles.Button
        style={{ minWidth: 125 }}
        onClick={() => usePost(`/api/product/variant/${productVariant}/bundles/`, { ...{ added, bundle: true } }, csrf)}
      >
        Update
      </GlobalStyles.Button>
    </>
  )

  return (
    <GenericModal
      heading={'Product Variant Settings'}
      show={open}
      onHide={() => setOpen(false)}
      buttons={buttons}
      size="lg"
    >
      <ProductModalStyled>
        <div style={{ margin: '0 2em' }}>
          <h2 style={{ marginTop: '1em' }}>Bundled Items</h2>
          <GlobalStyles.DataTable className="shadow-sm">
            <thead>
              <tr>
                <th>
                  <span className="text"></span>
                </th>
                <th>
                  <span className="text">Product Variant</span>
                </th>
                <th>
                  <span className="text center">Quantity</span>
                </th>
                <th>
                  <span className="text center">Remove</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(added).map((a: any) => (
                <GlobalStyles.TableRow className={added[a].qty ? 'active' : ''} key={a}>
                  <TableCell
                    input={
                      <img
                        src={added[a].img}
                        alt="Product Variant"
                        className="product_image"
                        style={{ maxWidth: 50 }}
                      />
                    }
                  />
                  <TableCell
                    input={
                      <>
                        <Link to={`/product/variant/${added[a].pId}/`} rel="noreferrer" target="__none">
                          {added[a].sku}
                        </Link>
                        <div>{added[a].desc}</div>
                      </>
                    }
                  />
                  <TableCell center>
                    <Form.Control type="text" value={added[a].qty} style={{ width: 100, margin: 'auto' }} disabled />
                  </TableCell>
                  <TableCell
                    center
                    input={
                      <GlobalStyles.Button
                        type="button"
                        className="secondary"
                        style={{ margin: 'auto' }}
                        onClick={() => {
                          handleRemoveItem(a)
                        }}
                      >
                        Remove
                      </GlobalStyles.Button>
                    }
                  />
                </GlobalStyles.TableRow>
              ))}
            </tbody>
          </GlobalStyles.DataTable>
          <h2 style={{ marginTop: '2em' }}>Add Items</h2>
          <div className="shadow-sm">
            <SearchBox {...{ search, setSearch, loading, setLoading, page, setPage }} />
            <div className="scrolltable" style={{ minHeight: 500, overflowY: 'scroll' }}>
              <GlobalStyles.DataTable>
                <thead>
                  <tr>
                    <th>
                      <span className="text"></span>
                    </th>
                    <th>
                      <span className="text">Product Variant</span>
                    </th>
                    <th>
                      <span className="text center">Quantity</span>
                    </th>
                    <th>
                      <span className="text center">Add</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {productSearch.map((p: any) => {
                    const { img, pId, sku, desc } = p
                    const qty = productCount[p.pId] ? productCount[p.pId] : ''
                    return (
                      <GlobalStyles.TableRow className={qty ? 'active' : ''} key={pId}>
                        <TableCell
                          input={
                            <img src={img} alt="Product Variant" className="product_image" style={{ maxWidth: 50 }} />
                          }
                        />
                        <TableCell
                          input={
                            <>
                              <Link to={`/product/variant/${pId}/`} rel="noreferrer" target="__none">
                                {sku}
                              </Link>
                              <div>{desc}</div>
                            </>
                          }
                        />
                        <TableCell
                          input={
                            <Form.Control
                              type="number"
                              min="1"
                              step="1"
                              value={qty}
                              style={{ width: 100, margin: 'auto' }}
                              onChange={(e) => setProductCount({ ...productCount, [p.pId]: e.target.value } as any)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  handleAddItem(p)
                                }
                              }}
                            />
                          }
                          center
                        />
                        <TableCell
                          input={
                            <GlobalStyles.Button
                              type="button"
                              onClick={(e) => {
                                handleAddItem(p)
                              }}
                              style={{ color: 'white' }}
                            >
                              Add
                            </GlobalStyles.Button>
                          }
                        />
                      </GlobalStyles.TableRow>
                    )
                  })}
                </tbody>
              </GlobalStyles.DataTable>
            </div>
          </div>
        </div>
      </ProductModalStyled>
    </GenericModal>
  )
}

export const BundleCard = () => {
  const [open, setOpen] = useState(false)

  const productVariant = useParams<{ id: string }>().id

  const {
    response: resp,
    loaded: loaded,
    error,
    placeholder,
  } = useFetch(`/api/product/variant/${productVariant}/bundles/`, {})
  const bundleItems = loaded ? resp?.bundleItems || [] : []

  return (
    <BackgroundLayer style={{ display: 'block', position: 'relative', padding: '1em', minHeight: 200 }}>
      <GlobalStyles.CardHeader style={{ padding: '0 12px' }}>
        <GlobalStyles.CardTitle>
          <h3>
            Bundle Items<small>{bundleItems ? bundleItems.length : 0} Total</small>
          </h3>
        </GlobalStyles.CardTitle>
        <GlobalStyles.CardToolbar>
          <GlobalStyles.Button style={{ height: 40, marginRight: '-0.5em' }} onClick={() => setOpen(true)}>
            Modify
          </GlobalStyles.Button>
          <BundleModal {...{ open, setOpen, bundleItems }} />
        </GlobalStyles.CardToolbar>
      </GlobalStyles.CardHeader>
      <div style={{ width: '100%' }}>
        <GlobalStyles.DataTable>
          <thead>
            <tr>
              <th>
                <span className="text"></span>
              </th>
              <th>
                <span className="text">Product Variant</span>
              </th>
              <th>
                <span className="text center">Quantity</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {bundleItems.map(({ img, pId, sku, desc, qty }: any) => (
              <GlobalStyles.TableRow key={pId}>
                <TableCell
                  input={<img src={img} alt="Product Variant" className="product_image" style={{ maxWidth: 50 }} />}
                />
                <TableCell
                  input={
                    <>
                      <Link to={`/product/variant/${pId}/`} rel="noreferrer" target="__none">
                        {sku}
                      </Link>
                      <div>{desc}</div>
                    </>
                  }
                />
                <TableCell input={qty} center />
              </GlobalStyles.TableRow>
            ))}
          </tbody>
        </GlobalStyles.DataTable>
      </div>
      {!loaded ? <CardLoading text={placeholder} error={error} /> : null}
    </BackgroundLayer>
  )
}
